import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelNueve.scss";

import Pacmanl from "../../assets/images/home/pacmanl.svg";
import Pacmanr from "../../assets/images/home/pacmanr.svg";
import Pacmanb from "../../assets/images/home/pacmanb.svg";
import Pacmant from "../../assets/images/home/pacmant.svg";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const images = [
  { image: "one", icon: Pacmanr, clicked: false, x: 0, y: 0, move: "Right" },
  { image: "one", icon: Pacmant, clicked: false, x: 0, y: 1, move: "Top" },
  { image: "one", icon: Pacmanr, clicked: false, x: 0, y: 2, move: "Right" },
  { image: "one", icon: Pacmanb, clicked: false, x: 0, y: 3, move: "Bottom" },
  { image: "one", icon: Pacmant, clicked: false, x: 1, y: 0, move: "Top" },
  { image: "one", icon: Pacmanr, clicked: false, x: 1, y: 1, move: "Right" },
  { image: "one", icon: Pacmanb, clicked: false, x: 1, y: 2, move: "Bottom" },
  { image: "one", icon: Pacmanr, clicked: false, x: 1, y: 3, move: "Right" },
  { image: "one", icon: Pacmanl, clicked: false, x: 2, y: 0, move: "Left" },
  { image: "one", icon: Pacmanb, clicked: false, x: 2, y: 1, move: "Bottom" },
  { image: "one", icon: Pacmanl, clicked: false, x: 2, y: 2, move: "Left" },
  { image: "one", icon: Pacmanr, clicked: false, x: 2, y: 3, move: "Right" },
  { image: "one", icon: Pacmant, clicked: false, x: 3, y: 0, move: "Top" },
  { image: "one", icon: Pacmanl, clicked: false, x: 3, y: 1, move: "Left" },
  { image: "one", icon: Pacmanl, clicked: false, x: 3, y: 2, move: "Left" },
  { image: "one", icon: Pacmanb, clicked: false, x: 3, y: 3, move: "Bottom" },
];

function LevelNueve() {
  const [tiles, setTiles] = useState(images);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    timeForFirstFish: 0,
    clicksForFirstFish: 0,
    timeForSecondFish: 0,
    clicksForSecondFish: 0,
    totalTime: 0,
    totalHints: 0,
  });
  const [timer, setTimer] = useState(0);
  const [clicks, setClicks] = useState(0);
  const [righClicks, setRightClicks] = useState(0);

  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  const movePacMan = (index, direction, x, y) => {
    let tempClicks = clicks + 1;
    setClicks(clicks + 1);
    let canBeMoved = true;
    switch (direction) {
      case "Right":
        tiles.map((item) => {
          if (item.x === x && item.y > y) {
            canBeMoved = canBeMoved && item.clicked ? true : false;
          }
        });
        break;
      case "Left":
        tiles.map((item) => {
          if (item.x === x && item.y < y) {
            canBeMoved = canBeMoved && item.clicked ? true : false;
          }
        });
        break;
      case "Top":
        tiles.map((item) => {
          if (item.x < x && item.y === y) {
            canBeMoved = canBeMoved && item.clicked ? true : false;
          }
        });
        break;
      case "Bottom":
        tiles.map((item) => {
          if (item.x > x && item.y === y) {
            canBeMoved = canBeMoved && item.clicked ? true : false;
          }
        });
        break;
    }
    if (canBeMoved) {
      if (dataPoints.timeForFirstFish === 0) {
        setDataPoints({
          ...dataPoints,
          timeForFirstFish: timer,
          clicksForFirstFish: tempClicks
        });
      }
      let newTiles = tiles.map((item, i) => {
        if (index == i) {
          return { ...item, clicked: true };
        } else {
          return item;
        }
      });
      setTiles(newTiles);
    }
  };

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < tiles.length) {
      if (tiles[index].clicked === false) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === tiles.length) {
      const finalObj = {
        gameData: {
          levelData: [
            {
              level: 2,
              levelName: 'Pesca',
              timeForFirstFish: dataPoints.timeForFirstFish,
              clicksForFirstFish: dataPoints.clicksForFirstFish,
              // timeForSecondFish: dataPoints.timeForSecondFish,
              // clicksForSecondFish: dataPoints.clicksForSecondFish,
              totalClicks: clicks,
              totalTime: timer,
              isLevelCleared: true,
              isLevelSkipped: false,
              totalHintsTaken: localStorage.getItem("totalHints"),
              timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
              timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
            }
          ],
        }
      }
      console.log(finalObj)
      sendResult(finalObj)
      setWon(true);
      // setDataPoints({
      //   ...dataPoints,
      //   totalTime: timer,
      // })
    }
  }, [tiles]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true)
      }
    }, 1000);
  }, [won]);

  return (
    <div className="component-level-nueve">
      {move && <LevelComplete levelNum={2} />}
      <Navbar won={won} levelNum={2} />
      <div className="game-container">
        {tiles.map((item, index) => (
          <div key={index} className="tile">
            <div className="tile-inside">
              <img
                className={item.clicked ? `move${item.move}` : ``}
                onClick={() => movePacMan(index, item.move, item.x, item.y)}
                src={item.icon}
                alt={item.type}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LevelNueve;
